
jQuery(document).ready(function ($) {
	
    // Configurator page.
    (function () {
        if (!document.body.classList.contains("page-template-template-configurator")) {
            return;
        }

        var configurator_container = $(".configurator-container");
        if (configurator_container.length < 1) {
            return;
        }

        // Configurator data.
        var url_base = "/wp-content/themes/chudej/img/configurator/new/";
        var configurator_images = get_configurator_images(url_base);
        var possible_products = new_products_json;
        var last_tab_index = 0;
        var tabs_order = [
            "design",
            "position",
            "outfall",
            "diameter",
            "frame",
            "size"
        ];

        var current_lang = $("html").attr("lang");

        var modal = $(".modal#orderNumberModal");

        // Tab button click.
        configurator_container.find(".configurator-tabs .configurator-tab .btn-chudej").on("click", function(e) {
            e.preventDefault();
    
            var this_el = $(this);
            var this_parent = this_el.parent();
            if (this_parent.hasClass("disabled")) {
                modal.find(".modal-body").text(text_json[0]);
                
                // Show modal.
                modal.modal();

                return;
            }

            if (!this_parent.hasClass("active") && !this_el.hasClass("active")) {
                this_parent.siblings().removeClass("active");
                this_parent.addClass("active");
    
                this_el.closest(".configurator-tabs").find(".btn-chudej").removeClass("active");
                this_el.addClass("active");
    
                if (window.matchMedia('(max-width: 767px)').matches) {
                    this_parent.find(".configurator-tab-menu").slideDown();
                }
            } else {
                this_parent.removeClass("active");
                this_el.removeClass("active");
    
                if (window.matchMedia('(max-width: 767px)').matches) {
                    this_parent.find(".configurator-tab-menu").slideUp();
                }
            }
        });

        /**
         * Remove button active class when clicking out of configurator.
         */
        $(document).click(function(event) {
            if (configurator_container.length > 0) {
                $target = $(event.target);
                btn_el = configurator_container.find('.configurator-tabs .configurator-tab .btn-chudej');

                if(!$target.closest('.configurator-tabs').length && btn_el.hasClass("active") && btn_el.parent().hasClass("active")) {
                    btn_el.removeClass("active");
                    btn_el.parent().removeClass("active");
                }
            }
        });

        // Tab menu button click.
        configurator_container.find(".configurator-tab-menu .tab-menu-btn").on("click", function(e) {
            e.preventDefault();
    
            var this_el = $(this);
            var parent_el = this_el.parent();
            if (!this_el.hasClass("active")) {
                parent_el.siblings().find(".tab-menu-btn").removeClass("active");
                this_el.addClass("active");
    
                parent_el.siblings().find(".fa").removeClass("fa-rotate-90");
                this_el.find(".fa").addClass("fa-rotate-90");
    
                parent_el.siblings().find(".tab-menu-options").slideUp();
                parent_el.find(".tab-menu-options").slideDown();
            }
        });

        // Option button click.
        if (current_lang == "cs-CZ") {
        configurator_container.find(".tab-menu-options .option-btn").on("click", function(e) {
            e.preventDefault();
    
            var $this = $(this);
            var id = $this.data("id") || "";
            var option_type = $this.data("type") || "";
            var position = $this.closest(".configurator-tabs").find(".tab-menu-options.position-options .option-btn.active").data("position") || "wall";
            var configurator_tab = $this.closest(".configurator-tab");
            var configurator_text = configurator_container.find(".configurator-text");
            var next_btn = configurator_tab.next();
            //var index = configurator_tab.index(".configurator-tab") + 1;
    
            if ($this.hasClass("active")) {
                return;
            }

            // Handle active classes.
            $this.siblings(".option-btn").removeClass("active");
            $this.addClass("active");

            if (option_type == "text") {
                var text_class = $this.data("class");
                var text = $this.text();
                var text_container = configurator_text.find("."+text_class+"-container");
                
                text_container.find("."+text_class).text(text);

                if (!text_container.hasClass("active")) {
                    text_container.addClass("active").fadeIn();
                }

                if (text_class == "position") {
                    var new_position = $this.data("position");

                    var id = configurator_container.find(".designs .option-btn.active").data("id") || 1;
                    var type = configurator_container.find(".designs .option-btn.active").data("type") || "lesk";
                    var material = $(".configurator-container .configurator-text").find(".frame").text() || "plast";
                    var key = get_configurator_key(new_position, type, material);
                    var new_src = configurator_images[key][id-1];
                    configurator_container.find(".configurator-images img:not(.configurator-bg)").attr("src", new_src);
                } else if (text_class == "frame") {
                    var new_material = $this.data("frame");

                    var id = configurator_container.find(".designs .option-btn.active").data("id") || 1;
                    var type = configurator_container.find(".designs .option-btn.active").data("type") || "lesk";
                    var position = $(".configurator-container .configurator-text").find(".position").text() || "";
                    if (position == text_json[21]) {
                        position = "area";
                    } else {
                        position = "wall";
                    }
                    var key = get_configurator_key(position, type, new_material);
                    var new_src = configurator_images[key][id-1];
                    configurator_container.find(".configurator-images img:not(.configurator-bg)").attr("src", new_src);
                }

            } else if (option_type != "bg") {
                // option_type == lesk || mat

                var text_class = $this.data("class");
                var text = option_type;
                
                if (current_lang != "cs-CZ") {
                    text = $this.closest(".tab-menu-option").find(".tab-menu-btn").text();
                }
                
                var name = $this.data("name");
                var text_container = $this.closest(".configurator-tabs-container").find(".configurator-text-container .configurator-text ."+text_class+"-container");
                
                $this.closest(".configurator-tabs-container").find(".configurator-text-container .configurator-text ."+text_class).text(text);
                $this.closest(".configurator-tabs-container").find(".configurator-text-container .configurator-text .design-name").text(name);

                if (!text_container.hasClass("active")) {
                    text_container.addClass("active").fadeIn();
                }

                var type = option_type;
                var material = $(".configurator-container .configurator-text").find(".frame").text() || "plast";
                var key = get_configurator_key(position, type, material);

                var new_src = configurator_images[key][id-1];

                configurator_container.find(".configurator-images img:not(.configurator-bg)").addClass("active").attr("src", new_src);
            } else {
                // option_type == bg
                var new_src = configurator_images.background_images[id-1];
                configurator_container.find(".configurator-images img.configurator-bg").attr("src", new_src);
            }
            
            // Handle showing of possible options.
            if (option_type == "text" && next_btn.length > 0) {

                var current_tab_index = tabs_order.indexOf(text_class);

                if (current_tab_index <= last_tab_index) {

                    possible_products = new_products_json;
    
                    for (var i = 1; i < current_tab_index; i++) {
                        var old_text_class = tabs_order[i];

                        var old_text = configurator_text.find("."+old_text_class).text();
                        
                        possible_products = possible_products.filter(function(value, index, array) { 
                            return value[old_text_class].label == old_text;
                        });
                    }

                    for (var i = tabs_order.length; i > current_tab_index; i--) {
                        var old_text_class = tabs_order[i];
                        
                        var old_text_container = configurator_text.find("."+old_text_class+"-container");
                        old_text_container.removeClass("active").fadeOut().find("."+old_text_class).text("");
                    }
    
                }

                possible_products = possible_products.filter(function(value, index, array) {
                    return value[text_class].label == text;
                });

                if (possible_products.length > 0) {

                    var tab_options = configurator_tab.next().find(".option-btn");

                    // Prepare data for sizes.
                    if (tab_options.hasClass("size")) {
                    }

                    // First hide all options.
                    tab_options.hide();

                    // Then show only available options.
                    tab_options.each(function(option_index) {

                        // Option data.
                        var this_option = $(this);
                        var option_text = this_option.text();
                        var option_text_number = parseInt(option_text);
                        var option_text_class = this_option.data("class");
                        var next_option_type = this_option.data("type");

                        // Reset active option.
                        //if (this_option.hasClass("active") && option_text != product_label) {
                        if (this_option.hasClass("active")) {
                            this_option.removeClass("active");

                            var option_text_container = configurator_container.find(".configurator-text ."+option_text_class+"-container");

                            option_text_container.removeClass("active").fadeOut();
                            option_text_container.find("."+option_text_class).text("");
                        }
    
                        for (var product_index in possible_products) {
                            var product = possible_products[product_index];

                            if (next_option_type == "text" && option_text_class != "size") {
                                var product_label = product[option_text_class].label
                                
                                // Show available option.
                                if (option_text == product_label) {
                                    this_option.show();
                                }

                            } else if (option_text_class == "size") {

                                product_variations = product.variations;
                                if (option_text_class == "size" && product_variations) {
                                    
                                    //loop through all product variations
                                    for (var variation_index in product_variations) {
                                        var variation = product_variations[variation_index];
                                        var variation_attributes = variation.attributes;

                                        if (variation_attributes["attribute_pa_delka-mrizky"] == option_text_number) {
                                            this_option.show();
                                        }
                                    }

                                }

                            }
        
                        }
    
                    });

                }

                last_tab_index = current_tab_index;
            }

            if (possible_products.length < 1) {
                console.log("no possible products found");
            }

            // Enable next button.
            if (next_btn.length > 0) {
                next_btn.removeClass("disabled");
                
                // Disable all buttons after next button.
                if (option_type == "text") {
                    var next_btns = next_btn.nextAll();
                    if (next_btn.length > 0) {
                        next_btns.addClass("disabled");
                    }
                }
            }
            
            if (current_lang == "cs-CZ") {
                new_configurator_order("option-btn");
            } else {
                configurator_order("option-btn");
            }
            
        });
        } else {

            $(document).on("click", ".configurator-container .tab-menu-options .option-btn", function(e) {
                e.preventDefault();
        
                var $this = $(this);
                var id = $this.data("id") || "";
                var type = $this.data("type") || "";
                var position = $this.closest(".configurator-tabs").find(".tab-menu-options.position-options .option-btn.active").data("position") || "wall";
                var next_btn = $this.closest(".configurator-tab").next();
                var index = $this.closest(".configurator-tab").index(".configurator-tab") + 1;
        
                if (!$this.hasClass("active")) {
                    $this.closest(".configurator-tab-menu").find(".option-btn").removeClass("active");
        
                    $this.addClass("active");
        
                    if (type == "text") {
                        var text_class = $this.data("class");
                        var text = $this.text();
                        var text_container = $this.closest(".configurator-tabs-container").find(".configurator-text-container .configurator-text ."+text_class+"-container");
                        
                        $this.closest(".configurator-tabs-container").find(".configurator-text-container .configurator-text ."+text_class).text(text);
        
                        if (!text_container.hasClass("active")) {
                            text_container.addClass("active").fadeIn();
                        }
        
                        //Odtok je index 1
                        //if (index == 1) {
                        if (index == 3) {
                            if (text.indexOf(text_json[24]) >= 0) {
                                //$(".configurator-tabs .configurator-tab:nth-child(2)").fadeOut();
        
                                //next_btn je zde Průměr odtoku
                                next_btn.find(".option-btn:nth-child(2)").trigger("click");
                                next_btn.find(".option-btn:nth-child(1)").hide();
        
                                //.configurator-tab:nth-child(5) je zde Design rámečku roštu
                                /*$(".configurator-tabs .configurator-tab:nth-child(5) .option-btn:nth-child(1)").fadeOut();
                                $(".configurator-tabs .configurator-tab:nth-child(5) .option-btn:nth-child(2)").trigger("click");*/
        
                                /*$(".configurator-tabs .configurator-tab:nth-child(3) .option-btn:nth-child(1)").fadeOut();
                                $(".configurator-tabs .configurator-tab:nth-child(3) .option-btn:nth-child(2)").fadeOut();
                                $(".configurator-tabs .configurator-tab:nth-child(3) .option-btn:nth-child(3)").fadeOut();*/
                            } else {
                                //$(".configurator-tabs .configurator-tab:nth-child(2)").fadeIn();
                                //next_btn je zde Průměr odtoku
                                next_btn.find(".option-btn:nth-child(1)").show();
                                $(".configurator-tabs .configurator-tab:nth-child(5) .option-btn:nth-child(1)").show();
        
                                /*$(".configurator-tabs .configurator-tab:nth-child(3) .option-btn:nth-child(1)").fadeIn();
                                $(".configurator-tabs .configurator-tab:nth-child(3) .option-btn:nth-child(2)").fadeIn();
                                $(".configurator-tabs .configurator-tab:nth-child(3) .option-btn:nth-child(3)").fadeIn();*/
                            }
        
                            if (text == "spodní") {
                                //next_btn je zde Průměr odtoku
                                next_btn.find(".option-btn:nth-child(1)").removeClass("mb-4").trigger("click");
                                next_btn.find(".option-btn:nth-child(2)").hide();
                            } else {
                                //next_btn je zde Průměr odtoku
                                next_btn.find(".option-btn:nth-child(1)").addClass("mb-4");
                                next_btn.find(".option-btn:nth-child(2)").show();
                            }
                        }
        
                        if (text_class == "position") {
                            var new_position = $this.data("position");
        
                            if (new_position == "wall") {
                                if (!window.matchMedia('(max-width: 767px)').matches) {
                                    next_btn.find(".option-btn:nth-child(1):visible").hide();
                                } else {
                                    next_btn.find(".option-btn:nth-child(1)").hide();
                                }
                            } else {
                                if (!window.matchMedia('(max-width: 767px)').matches) {
                                    next_btn.find(".option-btn:nth-child(1):hidden").show();
                                } else {
                                    next_btn.find(".option-btn:nth-child(1)").show();
                                }
                            }
        
                            //var current_img = $this.closest(".configurator-container").find(".configurator-images img:not(.configurator-bg).active");
                            //var current_img_id = current_img.data("id");
                            //var current_img_type = current_img.data("type");
        
                            //current_img.removeClass("active");
        
                            var id = $this.closest(".configurator-container").find(".designs .option-btn.active").data("id") || 1;
                            var type = $this.closest(".configurator-container").find(".designs .option-btn.active").data("type") || "lesk";
                            var material = $(".configurator-container .configurator-text").find(".frame").text() || "plast";
                            var key = get_configurator_key(new_position, type, material);
                            var new_src = configurator_images[key][id-1];
                            $this.closest(".configurator-container").find(".configurator-images img:not(.configurator-bg)").attr("src", new_src);
                            //$this.closest(".configurator-container").find(".configurator-images img:not(.configurator-bg)[data-type="+current_img_type+"][data-id="+current_img_id+"][data-position="+new_position+"]").addClass("active");
                        } else if (text_class == "frame") {
                            var new_material = $this.data("frame");
        
                            var id = $this.closest(".configurator-container").find(".designs .option-btn.active").data("id") || 1;
                            var type = $this.closest(".configurator-container").find(".designs .option-btn.active").data("type") || "lesk";
                            var position = $(".configurator-container .configurator-text").find(".position").text() || "";
                            if (position == text_json[21]) {
                                position = "area";
                            } else {
                                position = "wall";
                            }
                            var key = get_configurator_key(position, type, new_material);
                            var new_src = configurator_images[key][id-1];
                            $this.closest(".configurator-container").find(".configurator-images img:not(.configurator-bg)").attr("src", new_src);
                        }
                    } else if (type != "bg") {
                        //type == lesk || mat
        
                        var text_class = $this.data("class");
                        var text = type;
                        
                        var current_lang = $("html").attr("lang");
                        if (current_lang != "cs-CZ") {
                            text = $this.closest(".tab-menu-option").find(".tab-menu-btn").text();
                        }
                        
                        var name = $this.data("name");
                        var text_container = $this.closest(".configurator-tabs-container").find(".configurator-text-container .configurator-text ."+text_class+"-container");
                        
                        $this.closest(".configurator-tabs-container").find(".configurator-text-container .configurator-text ."+text_class).text(text);
                        $this.closest(".configurator-tabs-container").find(".configurator-text-container .configurator-text .design-name").text(name);
        
                        if (!text_container.hasClass("active")) {
                            text_container.addClass("active").fadeIn();
                        }
        
                        var material = $(".configurator-container .configurator-text").find(".frame").text() || "plast";
                        var key = get_configurator_key(position, type, material);
        
                        var new_src = configurator_images[key][id-1];
        
                        $this.closest(".configurator-container").find(".configurator-images img:not(.configurator-bg)").addClass("active").attr("src", new_src);
                        //$this.closest(".configurator-container").find(".configurator-images img:not(.configurator-bg)").removeClass("active");
                        //$this.closest(".configurator-container").find(".configurator-images img:not(.configurator-bg)[data-type="+type+"][data-id="+id+"][data-position="+position+"]").addClass("active");
                    } else {
                        //type == bg
                        var new_src = configurator_images.background_images[id-1];
                        $this.closest(".configurator-container").find(".configurator-images img.configurator-bg").attr("src", new_src);
                        //$this.closest(".configurator-container").find(".configurator-images img.configurator-bg").removeClass("active");
                        //$this.closest(".configurator-container").find(".configurator-images img.configurator-bg[data-type="+type+"][data-id="+id+"]").addClass("active");
                    }
        
                    var odtok = $(".configurator-container .configurator-text").find(".outfall").text();
                    var prumer = $(".configurator-container .configurator-text").find(".diameter").text();
        
                    if (odtok == text_json[22] && position == "wall") {
                        $(".configurator-tabs .configurator-tab:nth-child(4) .option-btn:nth-child(1)").removeClass("mb-4").trigger("click");
                        $(".configurator-tabs .configurator-tab:nth-child(4) .option-btn:nth-child(2):visible").hide();
                    }
        
                    //index 3 je Velikost žlabu / Délka mřížky
                    //if (index != 3) {
                    if (index != 6) {
                        // .configurator-tab:nth-child(3) je Velikost žlabu / Délka mřížky
                        $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(1):hidden").show();
                        $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(2):hidden").show();
                        $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(3):visible").hide();
                        $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(4):hidden").show();
                        $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(8):hidden").show();
                        $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(9):hidden").show();
            
                        if (odtok == text_json[22]) {
                            if (parseInt(prumer) == 40) {
                                $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(3):hidden").show();
                                $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(8):visible").hide();
                                $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(9):visible").hide();
                            } else {
                                $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(1):visible").hide();
                                $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(2):visible").hide();
                                $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(7)").show();
                                $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(9):visible").hide();
                            }
            
                        } else if (odtok == "spodní") {
                            if (parseInt(prumer) == 40) {
                                $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(1):visible").hide();
                                $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(2):visible").hide();
                                $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(9):visible").hide();
                            }
                        } else {
                            //odtok = otočný
                            $(".configurator-tabs .configurator-tab:nth-child(5) .option-btn:nth-child(1)").hide(); // zrusit plast
                            $(".configurator-tabs .configurator-tab:nth-child(5) .option-btn:nth-child(2)").trigger("click"); // klik na nerez
        
                            if (window.matchMedia('(max-width: 767px)').matches) {
                                $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(1)").hide();
                                $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(2)").hide();
                            } else {
                                $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(1):visible").hide();
                                $(".configurator-tabs .configurator-tab:nth-child(6) .option-btn:nth-child(2):visible").hide();
                            }
                        }
                    }
        
                    if (next_btn.length > 0 && next_btn.hasClass("disabled")) {
                        next_btn.removeClass("disabled");
                    }
                    
                    var current_lang = $("html").attr("lang");
                    if (current_lang == "cs-CZ") {
                        new_configurator_order("option-btn");
                    } else {
                        configurator_order("option-btn");
                    }
                }
            });

        }
    
        configurator_container.find(".print-btn").on("click", function(e) {
            e.preventDefault();
    
            if (current_lang == "cs-CZ") {
                new_configurator_order("print-btn");
            } else {
                configurator_order("print-btn");
            }
        });
    
        configurator_container.find(".mail-btn").on("click", function(e) {
            e.preventDefault();
    
            if (current_lang == "cs-CZ") {
                new_configurator_order("mail-btn");
            } else {
                configurator_order("mail-btn");
            }
        });
    
        configurator_container.find(".order-btn").on("click", function(e) {
            e.preventDefault();
    
            if (current_lang == "cs-CZ") {
                new_configurator_order("order-btn");
            } else {
                configurator_order("order-btn");
            }
        });
        
        configurator_container.find(".cart-btn").on("click", function(e) {
            e.preventDefault();
    
            if (current_lang == "cs-CZ") {
                new_configurator_order("cart-btn");
            } else {
                configurator_order("cart-btn");
            }
        });

        function get_configurator_images(url_base) {

            if (typeof url_base === "undefined") {
                return;
            }
        
            var background_images = [];
            background_images.push(url_base + "Tmavy.jpg");
            background_images.push(url_base + "Svetly.jpg");
        
            var stena_lesk_p = [];
            for (var i = 1; i <= 7; i++) {
                stena_lesk_p.push(url_base + "u-steny/" + i + "-lesk-p.png");
            }
        
            var stena_lesk_n = [];
            for (var i = 1; i <= 7; i++) {
                stena_lesk_n.push(url_base + "u-steny/" + i + "-lesk-n.png");
            }
        
            var stena_mat_p = [];
            for (var i = 1; i <= 7; i++) {
                stena_mat_p.push(url_base + "u-steny/" + i + "-mat-p.png");
            }
        
            var stena_mat_n = [];
            for (var i = 1; i <= 7; i++) {
                stena_mat_n.push(url_base + "u-steny/" + i + "-mat-n.png");
            }
        
            var prostor_lesk_p = [];
            for (var i = 1; i <= 7; i++) {
                prostor_lesk_p.push(url_base + "v-prostoru/" + i + "-lesk-p.png");
            }
        
            var prostor_lesk_n = [];
            for (var i = 1; i <= 7; i++) {
                prostor_lesk_n.push(url_base + "v-prostoru/" + i + "-lesk-n.png");
            }
        
            var prostor_mat_p = [];
            for (var i = 1; i <= 7; i++) {
                prostor_mat_p.push(url_base + "v-prostoru/" + i + "-mat-p.png");
            }
        
            var prostor_mat_n = [];
            for (var i = 1; i <= 7; i++) {
                prostor_mat_n.push(url_base + "v-prostoru/" + i + "-mat-n.png");
            }
        
            var images = {
                background_images: background_images,
                stena_lesk_p: stena_lesk_p,
                stena_lesk_n: stena_lesk_n,
                stena_mat_p: stena_mat_p,
                stena_mat_n: stena_mat_n,
                prostor_lesk_p: prostor_lesk_p,
                prostor_lesk_n: prostor_lesk_n,
                prostor_mat_p: prostor_mat_p,
                prostor_mat_n: prostor_mat_n
            }
        
            return images;
        }

        function get_configurator_key(position, type, material) {
            var key = "";
        
            if (position == "wall") {
                key += "stena_";
            } else if (position == "area") {
                key += "prostor_";
            }
        
            key += type;
        
            if (material == text_json[27] || material == text_previous_json[27]) {
                key += "_p";
            } else if (material == text_json[23] || material == text_previous_json[23]) {
                key += "_n";
            }
        
            return key;
        }
        
        function get_czech_text(searched_text) {
            if (searched_text == "") {
                return false;
            }
            
            if (text_json.includes(searched_text)) {
                var index = text_json.indexOf(searched_text);
                return text_previous_json[index];
            }

            return searched_text;
        }
        
        function configurator_order(context) {
            var ukaz_pouze_komplet = true;
        
            if (configurator_container.length < 1) {
                return;
            }

            var ajax_url = configurator_container.data("ajaxurl") || "";
    
            var configurator_text = $(".configurator-container .configurator-text");
            var odtok = configurator_text.find(".outfall").text();
            var prumer = configurator_text.find(".diameter").text();
            var velikost = parseInt(configurator_text.find(".size").text());
            var umisteni = configurator_text.find(".position").text();
            var design_ramecku = configurator_text.find(".frame").text();
            var design_rostu = configurator_text.find(".design").text();
            var czech_design_rostu = design_rostu;
            var design_nazev = configurator_text.find(".design-name").text();
            
            if (current_lang != "cs-CZ") {
                //console.log(odtok);
                odtok = get_czech_text(odtok);
                //console.log(odtok);
                prumer = get_czech_text(prumer);
                umisteni = get_czech_text(umisteni);
                design_ramecku = get_czech_text(design_ramecku);
                czech_design_rostu = get_czech_text(design_rostu.trim());
            }

            var search_array = [odtok, prumer, umisteni, design_ramecku];
            var filled_array = [odtok, prumer, velikost, umisteni, design_ramecku, design_rostu];
            //console.log(filled_array);
            //console.log(filled_array.length);
            //var number_filled = $.inArray("", search_array);
            var number_filled = 0;
            for (var i = 0; i < filled_array.length; i++) {
                if (i != 2 && filled_array[i] != "") {
                    number_filled++;
                } else if (i == 2 && !isNaN(filled_array[i])) {
                    number_filled++;
                }
            } 
            //console.log(number_filled, filled_array.length);
            if (number_filled == filled_array.length) {
                var all_filled = true;
            } else {
                var all_filled = false;
            }
            //console.log(all_filled);

            if (all_filled) {
                //reset modal body
                $(".modal.ordernumber-modal .modal-body").empty();

                var obsahuje = [];
                var neobsahuje = [];
                var search_word = "";
                var search_array_rdy = [];

                for (var i = 0; i < search_array.length; i++) {
                    search_word = search_array[i];
                    if (search_word == odtok) {
                        if (search_word.indexOf("výškov") >= 0 || search_word.indexOf(text_previous_json[24]) >= 0) {
                            search_word = "výškov";
                        } else if (search_word.indexOf(text_json[24]) >= 0 || search_word.indexOf(text_previous_json[24]) >= 0) {
                            search_word = "sifon";
                        }
                    } else if (search_word == prumer) {
                        search_word = parseInt(search_word).toString();
                    } else if (search_word == umisteni) {
                        if (search_word == text_json[25] || search_word == text_previous_json[25]) {
                            search_word = "stěn";
                        } else {
                            search_word = "";
                        }
                    } else if (search_word == design_ramecku) {
                        if (search_word == text_json[23] || search_word == text_previous_json[23]) {
                            search_word = "nerezový";
                        } else {
                            search_word = "";
                        }
                    }
                    search_array_rdy.push(search_word);
                }

                console.log("search_array_rdy");
                console.log(search_array_rdy);
                for (var i = 0; i < products_name_json.length; i++) {
                    var name = products_name_json[i];
                    if (search_array_rdy[0] == text_json[22] || search_array_rdy[0] == text_previous_json[22]) {

                        if (search_array_rdy[3] == "nerezový") {
                            if ((name.toLowerCase().indexOf(search_array_rdy[0]) >= 0) && (name.toLowerCase().indexOf(search_array_rdy[1]) >= 0) && (name.toLowerCase().indexOf(search_array_rdy[2]) >= 0) && (name.toLowerCase().indexOf(search_array_rdy[3]) >= 0)) {
                                if (search_array_rdy[0] != "sifon" && (name.toLowerCase().indexOf("sifon") >= 0)) {
                                    neobsahuje.push(name);
                                } else {
                                    obsahuje.push(name);
                                }
                            } else {
                                neobsahuje.push(name)
                            }
                        } else {
                            if ((name.toLowerCase().indexOf(search_array_rdy[0]) >= 0) && (name.toLowerCase().indexOf(search_array_rdy[1]) >= 0) && (name.toLowerCase().indexOf(search_array_rdy[2]) >= 0) && !(name.toLowerCase().indexOf("nerezový") >= 0)) {
                                if (search_array_rdy[0] != "sifon" && (name.toLowerCase().indexOf("sifon") >= 0)) {
                                    neobsahuje.push(name);
                                } else {
                                    obsahuje.push(name);
                                }
                            } else {
                                neobsahuje.push(name)
                            }
                        }

                    } else {
                        if (search_array_rdy[3] == "nerezový") {
                            if (name.toLowerCase().indexOf(search_array_rdy[0]) >= 0 && (name.toLowerCase().indexOf(search_array_rdy[3]) >= 0)) {
                                if (search_array_rdy[0] == "sifon") {
                                    if (name.toLowerCase().indexOf(search_array_rdy[1]) >= 0) {
                                        obsahuje.push(name);
                                    } else {
                                        neobsahuje.push(name);
                                    }
                                } else {
                                    obsahuje.push(name);
                                }
                            } else {
                                neobsahuje.push(name);
                            }
                        } else {
                            if (name.toLowerCase().indexOf(search_array_rdy[0]) >= 0 && !(name.toLowerCase().indexOf("nerezový") >= 0)) {
                                obsahuje.push(name);
                            } else {
                                neobsahuje.push(name);
                            }
                        }
                    }
                }
                //console.log(search_array_rdy);
                //console.log(search_array_rdy[0], search_array_rdy[1], search_array_rdy[2]);

                //console.log(search_word + " obsahují tyto žlaby:")
                console.log("zadaná kritéria nalezla:");
                console.log(obsahuje);
                //console.log(search_word + " neobsahují tyto žlaby:");
                console.log("zadaná kritéria nenalezla:");
                console.log(neobsahuje);

                if (obsahuje.length > 0) {
                    if (context == "order-btn") {
                        $(".modal.ordernumber-modal .modal-body").append("<h3 class='font-weight-bold mb-4'>" + obsahuje[0] + "</h3>");

                        if (current_lang == "cs-CZ") {
                            var table = '<table class="table table-bordered mb-0"><thead class="thead-light"><tr><th>'+text_json[1]+'</th><th>'+text_json[2]+'</th><th>'+text_json[3]+'</th><th>'+text_json[28]+'</th></tr></thead><tbody>';
                        } else {
                            var table = '<table class="table table-bordered mb-0"><thead class="thead-light"><tr><th>'+text_json[1]+'</th><th>'+text_json[2]+'</th></tr></thead><tbody>';
                        }
                    } else if (context == "mail-btn") {
                        var mail = "mailto:";
                        var subject = "?subject=" + encodeURIComponent($("h1").text());

                        var body = "&body=" + encodeURIComponent(text_json[4] + " \r\n \r\n" + text_json[5] + " " + odtok + "\r\n" + text_json[6] + " " + prumer + "\r\n" + text_json[7] + " " + velikost + "\r\n" + text_json[8] + " " + umisteni + "\r\n" + text_json[9] + " " + design_ramecku + "\r\n" + text_json[10] + " " + design_rostu + " | " + design_nazev);
                    }

                    var count = 0;
                    var count_failed = 0;
                    var sizes = [];
                    $(".zlaby .zlaby-komplet .product").each(function() {
                        if ($(this).find(".product-name").text() == obsahuje[0]) {

                            $(this).find(".product-tables table").each(function() {

                                var nazev = $(this).find("thead tr td:first-child").text().trim().replace(/\s/g, "").toLowerCase();
                                
                                if (nazev == design_nazev) {
                                    //console.log(nazev);

                                    count = $(this).find("tbody tr").length;
    
                                    $(this).find("tbody tr").each(function() {
        
                                        if ($(this).index() == 0) {
                                            if (design_rostu == "lesk" || czech_design_rostu == "lesk") {
                                                var order_number = $(this).find("td:nth-child(2)").text().trim();
                                            } else if (design_rostu == "mat" || czech_design_rostu == "mat") {
                                                var order_number = $(this).find("td:nth-child(3)").text().trim();
                                            }

                                            var size = $(this).find("td:nth-child(4)").text().trim();
                                        } else {
                                            if (design_rostu == "lesk" || czech_design_rostu == "lesk") {
                                                var order_number = $(this).find("td:nth-child(1)").text().trim();
                                            } else if (design_rostu == "mat" || czech_design_rostu == "mat") {
                                                var order_number = $(this).find("td:nth-child(2)").text().trim();
                                            }

                                            var size = $(this).find("td:nth-child(3)").text().trim();
                                        }
        
                                        if (size == velikost) {
                                            //strip html space entity
                                            order_number = order_number.replace(/\u00a0/g, " ");
                                            var product_index = products_csv_json.order_number.indexOf(order_number);
                                            var price = products_csv_json.price[product_index];
                                            console.log(order_number);
                                            console.log(products_csv_json);
                                            console.log(product_index);
                                            console.log(products_csv_json.price);
                                            console.log(price);
                                            console.log(parseInt(price));
                                            
                                            price = parseInt(price);
                                            var price_VAT = (21 / 100) * price;
                                            var price_with_VAT = Math.round(price + price_VAT);

                                            //table += "<tr><td>"+order_number+"</td><td>komplet</td><td>"+parseInt(prices_array[order_number.replace(/\s/g, "")])+" Kč</td></tr>";
                                            if (context == "order-btn") {
                                                if (current_lang == "cs-CZ") {
                                                    
                                                    table += "<tr><td>"+order_number+"</td><td>"+text_json[26]+"</td><td>"+price+" Kč</td><td>"+price_with_VAT+" Kč</td></tr>";
                                                } else {
                                                    table += "<tr><td>"+order_number+"</td><td>"+text_json[26]+"</td></tr>";
                                                }
                                            } else if (context == "mail-btn") {
                                                if (current_lang == "cs-CZ") {
                                                    body += encodeURIComponent("\r\n" + text_json[26] + ": " + order_number + " | " + price + " Kč" + " | " + price_with_VAT + " Kč");
                                                } else {
                                                    body += encodeURIComponent("\r\n" + text_json[26] + ": " + order_number);
                                                }
                                            } else if (context == "print-btn") {
                                                if (current_lang == "cs-CZ") {
                                                    $(".configurator-text-container .d-print-block .komplet").text(text_json[26] + " " + order_number + " | " + price + " Kč" + " | " + price_with_VAT + " Kč");
                                                } else {
                                                    $(".configurator-text-container .d-print-block .komplet").text(text_json[26] + " " + order_number);
                                                }
                                            } else if (context == "option-btn") {
                                                var show_price = false;
                                                
                                                if (show_price) {
                                                    var configurator_text = $(".configurator-text-container .configurator-text");
                                                    configurator_text.find(".price-container").addClass("active").fadeIn().find(".price").text(price_with_VAT + " Kč");
                                                    configurator_text.find(".price-vat-container").addClass("active").fadeIn().find(".price-vat").text(price + " Kč");
                                                }
                                            }
                                            //$(".modal.ordernumber-modal .modal-body").append("<br><br>objednací číslo: <strong>"+order_number+"</strong> | cena: <strong>"+parseInt(prices_array[order_number.replace(/\s/g, "")])+" Kč</strong>");
                                        } else {
                                            count_failed++;
                                            sizes.push(size);
                                        }
                                    });
                                }
                            });
                        }
                    });

                    if (!ukaz_pouze_komplet) {
                        $(".zlaby .zlaby-telo .product").each(function() {
                            if ($(this).find(".product-name").text() == obsahuje[0] + " – komplet balení bez mřížky") {
                                $(this).find("table:first-of-type tbody tr").each(function() {
                                    var velikost_table = $(this).find("td:nth-child(2)").text();
                                    if (velikost == velikost_table) {
                                        var order_number_table = $(this).find("td:nth-child(3)").text();
                                        var product_index = products_csv_json.order_number.indexOf(order_number_table);
                                        var price = products_csv_json.price[product_index];
    
                                        if (context == "order-btn") {
                                            table += "<tr><td>"+order_number_table+"</td><td>"+text_json[11]+"</td><td>"+parseInt(price)+" Kč</td></tr>";
                                        } else if (context == "mail-btn") {
                                            body += encodeURIComponent("\r\n" + text_json[13] + " " + order_number_table + " | " + parseInt(price) + " Kč");
                                        } else if (context == "print-btn") {
                                            $(".configurator-text-container .d-print-block .telo").text(text_json[12] + " " + order_number_table + " | " + parseInt(price) + " Kč");
                                        }
                                    }
                                });
                            }
                        });
                    }

                    if (!ukaz_pouze_komplet) {
                        $(".zlaby .zlaby-mrizka .product").each(function() {
                            
                            $(this).find(".product-tables table").each(function() {
    
                                var nazev = $(this).find("tbody tr:first-child td:first-child").text().toLowerCase();
    
                                if (nazev.indexOf(design_nazev) >= 0) {
    
                                    $(this).find("tbody tr").each(function() {
                                        if (design_rostu == "lesk") {
                                            var order_number_table = $(this).find("td:first-child").text();
                                        } else if (design_rostu == "mat") {
                                            var order_number_table = $(this).find("td:last-child").text();
                                        }
    
                                        if (order_number_table.indexOf(velikost) >= 0) {
                                            var product_index = products_csv_json.order_number.indexOf(order_number_table);
                                            var price = products_csv_json.price[product_index];
    
                                            if (context == "order-btn") {
                                                table += "<tr><td>"+order_number_table+"</td><td>"+text_json[14]+"</td><td>"+parseInt(price)+" Kč</td></tr>";
                                            } else if (context == "mail-btn") {
                                                body += encodeURIComponent("\r\n" + text_json[15] + " " + order_number_table + " | " + parseInt(price) + " Kč");
                                            } else if (context == "print-btn") {
                                                $(".configurator-text-container .d-print-block .mrizka").text(text_json[14]+" " + order_number_table + " | " + parseInt(price) + " Kč");
                                            }
                                        }
                                    });
    
                                }
                                
                            });
                        });
                    }

                    if(context == "print-btn") {
                        $(".configurator-text-container .d-print-block .mrizka").text(text_json[16]);
                    }

                    if (context == "order-btn") {
                        table += "</table>";
                    }
                    //console.log(count_failed, count);
                    if (count_failed != count) {
                        if (context == "order-btn") {
                            $(".modal.ordernumber-modal .modal-body").append(table);
                        } else if (context == "mail-btn") {
                            var mail_table = '<table style="font-family: Arial; font-size: 12px; color:#868686; border-collapse: collapse;">';
                            mail_table += '<tbody><tr>';
                            mail_table += '<td>';
                            mail_table += '<img src="https://www.chudej.cz/android-chrome-256x256.png">';
                            mail_table += '</td>';
                            mail_table+= '</tr></tbody>';
                            mail_table += "</table>";
                            //body += mail_table;
                            var mail_address = "\r\n \r\n";
                            mail_address += "Chuděj s.r.o.\r\n";
                            mail_address += "756 62 Hutisko-Solanec 310\r\n";
                            mail_address += "Česká republika";
                            body += encodeURIComponent(mail_address);
                            mail = mail + subject + body;
                            window.location.href = mail;
                        } else if (context == "print-btn") {
                            window.print();
                        }
                    } else {
                        //console.log(sizes);
                        $(".modal .modal-body").append(text_json[17]+"<br><br><br>"+text_json[18]+"<br>");
                        for (var i = 0; i < sizes.length; i++) {
                            $(".modal .modal-body").append(sizes[i] + "<br>");
                        }
                        if (context == "mail-btn" || context == "print-btn") {
                            $("#orderNumberModal").modal();
                        }
                    }
                } else {
                    $(".modal .modal-body").text(text_json[20]);

                    if (context == "mail-btn" || context == "print-btn") {
                        $("#orderNumberModal").modal();
                    }
                }
            } else {
                $(".modal .modal-body").text(text_json[19]);
                if (context == "mail-btn" || context == "print-btn") {
                    $("#orderNumberModal").modal();
                }
            }
        
        }
        
        function new_configurator_order(context) {

            if (!context) {
                return;
            }
            
            //configurator values
            var configurator_text = configurator_container.find(".configurator-text");
            var selected_outfall = configurator_text.find(".outfall").text(); //odtok
            var selected_diameter = configurator_text.find(".diameter").text(); //prumer
            var selected_size = parseInt(configurator_text.find(".size").text()); //velikost
            var selected_position = configurator_text.find(".position").text(); //umisteni
            var selected_frame = configurator_text.find(".frame").text(); //design ramecku
            var selected_design = configurator_text.find(".design").text(); //design rostu
            var selected_type_design = configurator_text.find(".design-name").text(); //design nazev
            
            // Put text in modal heading.
            if (context == "order-btn") {
                modal.find(".modal-header h2").text(text_json[1]);
            } else if (context == "mail-btn") {
                modal.find(".modal-header h2").text(text_json[30]);
            } else if (context == "print-btn") {
                modal.find(".modal-header h2").text(text_json[29]);
            } else if (context == "cart-btn") {
                modal.find(".modal-header h2").text(text_json[31]);
            }
            
            // Check if all values in configurator were selected.
            if (selected_outfall == "" || selected_diameter == "" || isNaN(selected_size) || selected_position == "" || selected_frame == "" || selected_design == "" || selected_type_design == "") {
                modal.find(".modal-body").text(text_json[19]);
                
                // Show modal if not button with data-toggle.
                if (context != "order-btn" && context != "option-btn") {
                    modal.modal();
                }

                if (context == "option-btn") {
                    configurator_text.find(".price-container").removeClass("active").fadeOut().find(".price").text("");
                    configurator_text.find(".price-vat-container").removeClass("active").fadeOut().find(".price-vat").text("");
                }
                
                return;
            }
            
            // Replace "/"" with "-"" in
            var old_selected_type_design = selected_type_design;
            selected_type_design = selected_type_design.replace("/", "-");
            
            // Reset modal body.
            modal.find(".modal-body").empty();
            
            //console.log(selected_outfall, selected_diameter, selected_size, selected_position, selected_frame, selected_design, selected_type_design);
            
            var product_found = false;
            
            //loop through all products
            for (var product_index in new_products_json) {
                var product = new_products_json[product_index];
                
                //product values
                var product_id = product.id;
                var product_name = product.name;
                var product_link = product.permalink;
                var product_image_url = product.image_url;
                var product_type_design = product.type_design;
                var product_design = product.design;
                var product_position = product.position;
                var product_outfall = product.outfall;
                var product_diameter = product.diameter;
                var product_frame = product.frame;
                var product_size = product.size;
                var product_variations = product.variations;
                
                //skip if no type design 
                if (product_type_design == null || product_type_design.value == 0) {
                    continue;
                }
                
                //skip if no design 
                if (product_design == null || product_design.value == 0) {
                    continue;
                }
                
                //skip if no position 
                if (product_position == null || product_position.value == 0) {
                    continue;
                }
                
                //skip if no outfall 
                if (product_outfall == null || product_outfall.value == 0) {
                    continue;
                }
                
                //skip if no diameter 
                if (product_diameter == null || product_diameter.value == 0) {
                    continue;
                }
                
                //skip if no frame 
                if (product_frame == null || product_frame.value == 0) {
                    continue;
                }
                
                //skip if no size 
                if (product_size == null || product_size.value == 0) {
                    continue;
                }

                //skip if no variations 
                if (product_variations == null) {
                    continue;
                }
                
                var variation_found = false;
                
                //loop through all product variations
                for (var variation_index in product_variations) {
                    var variation = product_variations[variation_index];

                    var is_same_type_design = false;
                    var is_same_design = false;
                    var is_same_size = false;
                    
                    // variation values
                    var variation_id = variation.id;
                    var variation_order_number = variation.order_number;
                    var variation_price_with_vat = Math.round(variation.price_with_vat * 1000) / 1000;
                    var variation_price_without_vat = Math.round(variation.price_without_vat * 1000) / 1000;
                    
                    //variation attributes
                    var variation_attributes = variation.attributes;
                    var variation_type_design = variation_attributes["attribute_pa_mrizky"];
                    var variation_design = variation_attributes["attribute_pa_design-mrizky"];
                    var variation_size = variation_attributes["attribute_pa_delka-mrizky"];
                    
                    //check if this variation has the selected type design
                    if (product_type_design != null && product_type_design.value == 1 && variation_type_design == selected_type_design) {
                        is_same_type_design = true;
                    } else {
                        continue;
                    }
                    
                    //check if this variation has the selected design
                    if (product_design != null && product_design.value == 1 && variation_design == selected_design) {
                        is_same_design = true;
                    } else {
                        continue;
                    }
                    
                    //check if this variation has the selected size
                    if (product_size != null && product_size.value == 1 && variation_size == selected_size) {
                        is_same_size = true;
                    } else {
                        continue;
                    }
                    
                    //check if this variation has all selected values
                    if (is_same_type_design && is_same_design && is_same_size) {
                        variation_found = true;
                        break;
                    }
                }
                
                //skip if no variation found
                if (!variation_found) {
                    continue;
                }
                
                //skip if product position is not same as selected position
                if (product_position.label != selected_position) {
                    continue;
                }
                
                //skip if product outfall is not same as selected outfall
                if (product_outfall.label != selected_outfall) {
                    continue;
                }
                
                //skip if product diameter is not same as selected diameter
                if (product_diameter.label != selected_diameter) {
                    continue;
                }
                
                //skip if product frame is not same as selected frame
                if (product_frame.label != selected_frame) {
                    continue;
                }
                
                //this product shares all selected values
                product_found = true;
                
                //create found product object
                if (product_found) {
                    
                    var found_product = {
                        id: product_id,
                        name: product_name,
                        link: product_link,
                        image_url : product_image_url,
                        variation_id: variation_id,
                        order_number: variation_order_number,
                        price_with_vat: variation_price_with_vat,
                        price_without_vat: variation_price_without_vat,
                    };
                    
                    break;
                }
            }
            
            // No product has been found.
            if (!product_found) {
                
                // Remove previous price.
                if (context == "option-btn") {
                    var configurator_text = configurator_container.find(".configurator-text");
                    configurator_text.find(".price-container").removeClass("active").fadeOut().find(".price").text("");
                    configurator_text.find(".price-vat-container").removeClass("active").fadeOut().find(".price-vat").text("");
                }
                
                modal.find(".modal-body").text(text_json[20]);
        
                // Show modal .
                if (context != "order-btn" && context != "option-btn") {
                    modal.modal();
                }
                
                return;
            }
            
            //console.log(found_product);
            
            if (context == "order-btn") {
                // Create table with product information.
                modal.find(".modal-body").append("<h3 class='font-weight-bold mb-4'><a href='" + found_product.link + "' style='color: inherit;'>" + found_product.name + "</a></h3>");
        
                if (current_lang == "cs-CZ") {
                    var table = '<table class="table table-bordered mb-0"><thead class="thead-light"><tr><th>'+text_json[1]+'</th><th>'+text_json[2]+'</th><th>'+text_json[3]+'</th><th>'+text_json[28]+'</th></tr></thead><tbody>';
                    table += "<tr><td>"+found_product.order_number+"</td><td>"+text_json[26]+"</td><td>"+found_product.price_without_vat.toFixed(2)+" Kč</td><td>"+found_product.price_with_vat.toFixed(2)+" Kč</td></tr>";
                } else {
                    var table = '<table class="table table-bordered mb-0"><thead class="thead-light"><tr><th>'+text_json[1]+'</th><th>'+text_json[2]+'</th></tr></thead><tbody>';
                    table += "<tr><td>"+found_product.order_number+"</td><td>"+text_json[26]+"</td></tr>";
                }
                
                table += "</table>";
                
                modal.find(".modal-body").append(table);
                
            } else if (context == "mail-btn") {
                // Create email with product information.
                var mail = "mailto:";
                var subject = "?subject=" + encodeURIComponent($("#main h1").text());
        
                var body = "&body=" + encodeURIComponent(text_json[4] + " \r\n \r\n" + text_json[5] + " " + selected_outfall + "\r\n" + text_json[6] + " " + selected_diameter + "\r\n" + text_json[7] + " " + selected_size + "\r\n" + text_json[8] + " " + selected_position + "\r\n" + text_json[9] + " " + selected_frame + "\r\n" + text_json[10] + " " + selected_design + " | " + old_selected_type_design);
                
                if (current_lang == "cs-CZ") {
                    body += encodeURIComponent("\r\n" + text_json[26] + ": " + found_product.order_number + " | " + found_product.price_without_vat.toFixed(2) + " Kč" + " | " + found_product.price_with_vat.toFixed(2) + " Kč");
                } else {
                    body += encodeURIComponent("\r\n" + text_json[26] + ": " + found_product.order_number);
                }
                
                var mail_address = "\r\n \r\n";
                mail_address += "Chuděj s.r.o.\r\n";
                mail_address += "756 62 Hutisko-Solanec 310\r\n";
                mail_address += "Česká republika";
                body += encodeURIComponent(mail_address);

                mail = mail + subject + body;
                window.location.href = mail;
                
            } else if (context == "print-btn") {
                // Show print view.
                
                if (current_lang == "cs-CZ") {
                    configurator_container.find(".configurator-text-container .d-print-block .komplet").text(text_json[26] + " " + found_product.order_number + " | " + found_product.price_without_vat.toFixed(2) + " Kč" + " | " + found_product.price_with_vat.toFixed(2) + " Kč");
                } else {
                    configurator_container.find(".configurator-text-container .d-print-block .komplet").text(text_json[26] + " " + found_product.order_number);
                }
                
                //configurator_container.find(".configurator-text-container .d-print-block .mrizka").text(text_json[16]);
                
                window.print();
                
            } else if (context == "option-btn") {
                // Show product price.
                
                var configurator_text = configurator_container.find(".configurator-text");
                configurator_text.find(".price-container").addClass("active").fadeIn().find(".price").text(found_product.price_with_vat.toFixed(2) + " Kč");
                configurator_text.find(".price-vat-container").addClass("active").fadeIn().find(".price-vat").text(found_product.price_without_vat.toFixed(2) + " Kč");
                
            } else if (context == "cart-btn") {
                // Add product to cart.
                
                var ajax_url = configurator_container.data("ajaxurl") || "";
                var is_loading = false;
                
                var product_ids = [found_product.variation_id];
                var product_quantities = [1];
                
                if (ajax_url != "" && product_ids.length > 0 && !is_loading) {
                    
                    var modal_body = modal.find(".modal-body");
                    
                    //$(".modal .modal-body").html("<h3>" + "Produkt " + "<strong>" + found_product.name + "</strong>" + " se přidává do košíku." + "</h3>");
                    
                    var modal_body_content = "";
                    
                    modal_body_content += '<div class="woocommerce-info">' + 'Produkt se přidává do košíku!' + '</div>';
                    modal_body_content += '<div class="woocommerce-message" style="display: none;">' + 'Produkt byl úspěšně přidán do košíku!' + '</div>';
                    modal_body_content += '<div class="woocommerce-error" style="display: none;">' + 'Nastala chyba při přidávání produktu do košíku!' + '</div>';
                    
                    modal_body_content += '<div class="row">';
                    if (found_product.image_url) {
                        modal_body_content += '<div class="col-12 col-lg-6 pb-4"><img src="' + found_product.image_url + '"></div><div class="col-12 col-lg-6 text-center text-lg-left pb-4">';
                    } else {
                        modal_body_content += '<div class="col-12 text-center text-lg-left pb-4">';
                    }
                    
                    modal_body_content += '<h3>' + found_product.name + '</h3>';
                    modal_body_content += '<strong>' + found_product.price_with_vat.toFixed(2) +' Kč</strong>';
                    
                    modal_body_content += '</div>';
                    
                    modal_body_content += '<div class="woocommerce col-12 col-lg-6 mb-4 text-center">';
                    modal_body_content += '<a href="' + cart_link + '" class="button">' + 'Prohlédnout košík' + '</a>';
                    modal_body_content += '</div>';
                    
                    modal_body_content += '<div class="woocommerce col-12 col-lg-6 mb-4 text-center">';
                    modal_body_content += '<a href="' + checkout_link + '" class="button">' + 'Pokladna' + '</a>';
                    modal_body_content += '</div>';
                    
                    modal_body_content += '</div>';
                    
                    modal_body.html(modal_body_content);
                    
                    
                    modal.modal();
                    
                    $.ajax({
                        type: 'POST',
                        url: ajax_url,
                        dataType: "json",
                        data: {
                            action: "chudej_add_product_to_cart",
                            product_ids: product_ids,
                            product_quantities: product_quantities
                        },
                        success: function(data) {
                            //console.log(data);
        
                            var success = data.success;
                            if (success) {
                                //$(".modal .modal-body").html("<h3>" + "Produkt " + "<strong>" + found_product.name + "</strong>" + " byl úspěšně přidán do košíku." + "</h3>");
                                modal_body.find(".woocommerce-info").fadeOut(400, function() {
                                    modal_body.find(".woocommerce-message").fadeIn();
                                });
                                //alert("Produkt byl přidán do košíku.");
                                chudej_update_cart_number();
                            } else {
                                //$(".modal .modal-body").html("<h3>" + "Nastala chyba při přidávání produktu do košíku." + "</h3>");
                                modal_body.find(".woocommerce-info").fadeOut(400, function() {
                                    modal_body.find(".woocommerce-error").fadeIn();
                                });
                                console.error("ERROR");
                            }
                        },
                        error: function (xhr, status, error) {
                            modal.find(".modal-body").html("<h3>" + "Nastala chyba při přidávání produktu do košíku." + "</h3>");
                            console.error(xhr);
                            console.error(status);
                            console.error(error);
                        },
                        complete: function() {
                            is_loading = false;
                        }
                    });
                }
                
            }
            
            
        }

    })();
    
});
